import { render, staticRenderFns } from "./TemplateDocument.vue?vue&type=template&id=774aefef&scoped=true&"
import script from "./TemplateDocument.vue?vue&type=script&lang=js&"
export * from "./TemplateDocument.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDocument.vue?vue&type=style&index=0&id=774aefef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774aefef",
  null
  
)

export default component.exports